var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3346 25.667V4.33366C20.3346 3.62641 20.0537 2.94814 19.5536 2.44804C19.0535 1.94794 18.3752 1.66699 17.668 1.66699H12.3346C11.6274 1.66699 10.9491 1.94794 10.449 2.44804C9.94892 2.94814 9.66797 3.62641 9.66797 4.33366V25.667M4.33464 7.00033H25.668C27.1407 7.00033 28.3346 8.19423 28.3346 9.66699V23.0003C28.3346 24.4731 27.1407 25.667 25.668 25.667H4.33464C2.86188 25.667 1.66797 24.4731 1.66797 23.0003V9.66699C1.66797 8.19423 2.86188 7.00033 4.33464 7.00033Z",
    stroke: "#227B2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon2);
export default __webpack_public_path__ + "static/media/time-icon-2.fa7270fae6d48ae358a52308ce6413f9.svg";
export { ForwardRef as ReactComponent };